import { useEffect } from "react";

/*
  /women のトップの、画面に入ったときの動き (2026-10-09 オーナー「明らかにプロが作ったと言われるサイトに」)。

  決まりは次の通り。
  - 長さは --hx-d (400ms)、イージングは --m-out (motion-tokens の EASE_OUT) の1組だけ。数え上げはやめた (2026-10-12。読む前に数が動くと、止まるまで 0 から並ぶ字が読まれる)
  - 動かすのは transform と opacity だけ
  - 隠してから出す指定は、html.hx-motion と data-mo="wait" の両方がそろった所だけで効く。
    JS が動く前、動かなかったとき、prefers-reduced-motion のときは、どれもそろわないので最初から全部見える
  - 一度出たら終わり。スクロールに張り付く処理は置かない

  順番が大事なので書いておく。IntersectionObserver の最初の通知で、もう画面に入っている物は何もせずに外し、
  画面の外の物にだけ data-mo="wait" を付けてから html.hx-motion を付ける。逆にすると、途中から読み直したときや
  背の高い画面で、見えている物が一瞬消えてまた出る。

  印は class ではなく data-mo にする。React が className を描き直すと、足した class は消える。React が描かない属性は残る。

  最初の画面 (HeroEditorial) はここに入れない。hydration を待つと出だしが遅れるので、字は最初から見せ、動きは CSS の animation だけで足す (hp-css.ts の hpFvStrike)。
*/

/* 見出しの頭。旗の札と明朝の見出し、黄の箱の見出し (parts.tsx の SectionHead) */
const HEAD = ".hp .hx-head, .hp .hx-head-c";
/* 札の並び。親が画面に入ったら、子を1枚ずつ少し遅らせて出す。brand の黒い面 (.bp-e) は自前で動くので入れない。
   hx-mo-list はほかのページ (/lp/30days-challenge など) が並びに付けて同じ動きを借りるための印 */
const LIST = ".hp .hx-wyg-list, .hp .px-rail, .hp .hx-i-grid, .hp .hx-vcards, .hp .hx-vnums, .hp .hx-mo-list";
/* 「エンジニアの今」(EngineerMarket) の棒と印と線。親が画面に入ったら、中の棒が 0 から本当の長さまで伸びる。
   数字の字は動かさず最初から出す。伸びる向きは棒の根元 (transform-origin) で決め、幅や高さは変えない */
const BARS = ".hp .em-bars, .hp .em-drop, .hp .em-dv, .hp .em-pp, .hp .em-line";
export const MOTION_CSS = `
.hp{--hx-d:400ms;--hx-y:12px;--hx-step:50ms}
@media (min-width:900px){.hp{--hx-y:16px}}

@media (prefers-reduced-motion:no-preference){
  /* 見出しの頭。札、見出し、リードの順に上がる */
  html.hx-motion .hp .hx-head[data-mo="wait"]>*{opacity:0;transform:translateY(var(--hx-y))}
  html.hx-motion .hp .hx-head[data-mo="in"]>*{transition:opacity var(--hx-d) var(--m-out),transform var(--hx-d) var(--m-out)}
  html.hx-motion .hp .hx-head[data-mo="in"]>:nth-child(2){transition-delay:calc(var(--hx-step) * 2)}
  html.hx-motion .hp .hx-head[data-mo="in"]>:nth-child(n+3){transition-delay:calc(var(--hx-step) * 4)}

  /* 箱の見出し。黄の箱を ::before に移し、左から伸ばしてから字を出す。止まった形は動かさないときと同じ */
  html.hx-motion .hp .hx-head-c[data-mo]>.hx-flag,html.hx-motion .hp .hx-head-c[data-mo]>.hx-lede{transition:opacity var(--hx-d) var(--m-out),transform var(--hx-d) var(--m-out)}
  html.hx-motion .hp .hx-head-c[data-mo="wait"]>.hx-flag,html.hx-motion .hp .hx-head-c[data-mo="wait"]>.hx-lede{opacity:0;transform:translateY(var(--hx-y))}
  html.hx-motion .hp .hx-head-c[data-mo="in"]>.hx-lede{transition-delay:calc(var(--hx-step) * 6)}
  html.hx-motion .hp .hx-head-c[data-mo] .hx-bands>span{position:relative;isolation:isolate;background:none}
  html.hx-motion .hp .hx-head-c[data-mo] .hx-bands>span::before{content:"";position:absolute;inset:0;z-index:-1;transform-origin:left center;transition:transform var(--hx-d) var(--m-out)}
  html.hx-motion .hp .hx-head-c[data-mo] .hx-bands>span::before{background:var(--yellow)}
  html.hx-motion .hp .hx-head-c[data-mo] .hx-bands>.hx-br::before{transition-delay:calc(var(--hx-step) * 2)}
  html.hx-motion .hp .hx-head-c[data-mo] .hx-bt{transition:opacity var(--hx-d) var(--m-out);transition-delay:calc(var(--hx-step) * 3)}
  html.hx-motion .hp .hx-head-c[data-mo] .hx-br .hx-bt{transition-delay:calc(var(--hx-step) * 5)}
  html.hx-motion .hp .hx-head-c[data-mo="wait"] .hx-bands>span::before{transform:scaleX(0)}
  html.hx-motion .hp .hx-head-c[data-mo="wait"] .hx-bt{opacity:0}

  /* 札の並び。ずらしは 50ms、5枚目から先は同じ遅れにまとめる */
  html.hx-motion .hp [data-mo="wait"]:is(.hx-wyg-list,.px-rail,.hx-i-grid,.hx-vcards,.hx-vnums,.hx-mo-list)>*{opacity:0;transform:translateY(var(--hx-y))}
  html.hx-motion .hp [data-mo="in"]:is(.hx-wyg-list,.px-rail,.hx-i-grid,.hx-vcards,.hx-vnums,.hx-mo-list)>*{transition:opacity var(--hx-d) var(--m-out),transform var(--hx-d) var(--m-out)}
  html.hx-motion .hp [data-mo="in"]:is(.hx-wyg-list,.px-rail,.hx-i-grid,.hx-vcards,.hx-vnums,.hx-mo-list)>:nth-child(2){transition-delay:var(--hx-step)}
  html.hx-motion .hp [data-mo="in"]:is(.hx-wyg-list,.px-rail,.hx-i-grid,.hx-vcards,.hx-vnums,.hx-mo-list)>:nth-child(3){transition-delay:calc(var(--hx-step) * 2)}
  html.hx-motion .hp [data-mo="in"]:is(.hx-wyg-list,.px-rail,.hx-i-grid,.hx-vcards,.hx-vnums,.hx-mo-list)>:nth-child(4){transition-delay:calc(var(--hx-step) * 3)}
  html.hx-motion .hp [data-mo="in"]:is(.hx-wyg-list,.px-rail,.hx-i-grid,.hx-vcards,.hx-vnums,.hx-mo-list)>:nth-child(n+5){transition-delay:calc(var(--hx-step) * 4)}

  /* 「エンジニアの今」の棒。transform の scaleX だけで伸ばすので、棒の枠の幅は動かない。
     求人倍率とハローワークは根元が左と右、左右の棒グラフは中央のラベル側が根元。行の順は --i で 60ms ずつずらす */
  html.hx-motion .hp [data-mo="wait"] :is(.em-b,.em-dv-l i,.em-dv-r i,.em-drop-track i){transform:scaleX(0)}
  html.hx-motion .hp [data-mo="in"] :is(.em-b,.em-dv-l i,.em-dv-r i,.em-drop-track i){transition:transform 700ms var(--m-out);transition-delay:calc(var(--i,0) * 60ms)}
  html.hx-motion .hp .em-b{transform-origin:left center}
  html.hx-motion .hp .em-dv-r i{transform-origin:left center}
  html.hx-motion .hp :is(.em-dv-l i,.em-drop-track i){transform-origin:right center}
  /* ①の人の印。順に現れる */
  html.hx-motion .hp [data-mo="wait"] .em-ic{opacity:0}
  html.hx-motion .hp [data-mo="in"] .em-ic{transition:opacity 300ms var(--m-out);transition-delay:calc(var(--i,0) * 40ms)}
  /* 折れ線。pathLength を 1 にしてあるので、線の長さに関わらず左から引かれる */
  html.hx-motion .hp [data-mo] :is(.em-line-all,.em-line-eng){stroke-dasharray:1}
  html.hx-motion .hp [data-mo="wait"] :is(.em-line-all,.em-line-eng){stroke-dashoffset:1}
  html.hx-motion .hp [data-mo="in"] :is(.em-line-all,.em-line-eng){stroke-dashoffset:0;transition:stroke-dashoffset 800ms var(--m-out)}
  html.hx-motion .hp [data-mo="wait"] .em-dot-last{opacity:0}
  html.hx-motion .hp [data-mo="in"] .em-dot-last{transition:opacity 200ms var(--m-out) 700ms}
}

/* 押せるもの。hover で少し持ち上がり、押すと沈む。影は使わない */
@media (hover:hover) and (prefers-reduced-motion:no-preference){
  .hp .hx-pill,.hp .hp-fv-btn{transition:background-color var(--m-cta) var(--m-out),transform var(--m-cta) var(--m-out)}
  .hp .hx-pill:hover,.hp .hp-fv-btn:hover{transform:translateY(-2px)}
  .hp .hx-pill:active,.hp .hp-fv-btn:active{transform:translateY(1px)}
  .hp .hx-vfilms>.hx-vf{transition:transform var(--m-cta) var(--m-out)}
  .hp .hx-vfilms>.hx-vf:hover{transform:translateY(-2px)}
}

/* ヘッダーの節のリンク。今いる節の下線を、1本の線が横へ動いてついていく。
   線の位置と幅は JS が --hx-ux と --hx-uw (幅 px) に入れる。入るまでは今までどおりリンクごとの下線 */
@media (prefers-reduced-motion:no-preference){
  html.hx-motion:has(.hp) .gh-secrow ul[data-mo-u],html.hx-motion:has(.hp) .gh-nav[data-mo-u]{position:relative}
  html.hx-motion:has(.hp) .gh-secrow ul[data-mo-u] a[aria-current="true"]{border-bottom-color:transparent}
  html.hx-motion:has(.hp) .gh-nav[data-mo-u] .gh-link[aria-current="true"]::after{transform:scaleX(0)}
  html.hx-motion:has(.hp) :is(.gh-secrow ul,.gh-nav)[data-mo-u]::after{content:"";position:absolute;left:0;width:1px;height:3px;background:var(--gh-ink,#121417);pointer-events:none;transform-origin:left center;transform:translateX(var(--hx-ux,0)) scaleX(var(--hx-uw,0));transition:transform var(--hx-d,400ms) cubic-bezier(.2,.7,.2,1)}
  html.hx-motion:has(.hp) .gh-secrow ul[data-mo-u]::after{bottom:0}
  html.hx-motion:has(.hp) .gh-nav[data-mo-u]::after{bottom:6px}
  html.hx-motion:has(.hp) :is(.gh-secrow ul,.gh-nav)[data-mo-u="off"]::after{opacity:0}
}
`;

/* ヘッダーの今いる節に、1本の下線を動かしてつける */
function followUnderline(): () => void {
  const rows = Array.from(document.querySelectorAll<HTMLElement>(".gh-secrow ul, .gh-nav")).filter((row) =>
    row.querySelector('a[href^="#"]'),
  );
  const place = (row: HTMLElement) => {
    const cur = row.querySelector<HTMLElement>('a[aria-current="true"]');
    if (!cur || cur.offsetWidth === 0) {
      row.setAttribute("data-mo-u", "off");
      return;
    }
    /* 線は row の中の絶対配置なので、row の左の内側からの距離にする。横に流れる row はその分を足す */
    const x = cur.getBoundingClientRect().left - row.getBoundingClientRect().left - row.clientLeft + row.scrollLeft;
    row.style.setProperty("--hx-ux", `${x}px`);
    row.style.setProperty("--hx-uw", String(cur.offsetWidth));
    row.setAttribute("data-mo-u", "on");
  };
  const observers = rows.map((row) => {
    place(row);
    const mo = new MutationObserver(() => place(row));
    mo.observe(row, { subtree: true, attributes: true, attributeFilter: ["aria-current"] });
    return mo;
  });
  const onResize = () => rows.forEach(place);
  window.addEventListener("resize", onResize, { passive: true });
  return () => {
    observers.forEach((mo) => mo.disconnect());
    window.removeEventListener("resize", onResize);
    rows.forEach((row) => {
      row.removeAttribute("data-mo-u");
      row.style.removeProperty("--hx-ux");
      row.style.removeProperty("--hx-uw");
    });
  };
}

/** トップの動きを付ける。IndexPage で1回だけ呼ぶ。ページを離れるときに印を全部外す */
export function useHpMotion() {
  useEffect(() => {
    if (typeof IntersectionObserver === "undefined") return;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

    const html = document.documentElement;
    const targets: Element[] = [
      ...document.querySelectorAll(HEAD),
      ...document.querySelectorAll(LIST),
      ...document.querySelectorAll(BARS),
    ];
    /* 最初の通知が済んでから html.hx-motion を付ける。
       待たせるのは、画面より下にあって描かれている物だけ。もう見えている物、上へ過ぎた物、
       閉じた details の中の物 (開いた瞬間に透明で出てしまう) は何もしない */
    let first = true;
    const io = new IntersectionObserver(
      (entries) => {
        for (const e of entries) {
          const el = e.target as HTMLElement;
          if (first) {
            const closed = el.closest("details:not([open])");
            const below = e.boundingClientRect.top >= window.innerHeight;
            if (!below || closed) io.unobserve(el);
            else el.setAttribute("data-mo", "wait");
            continue;
          }
          if (!e.isIntersecting) continue;
          io.unobserve(el);
          el.setAttribute("data-mo", "in");
        }
        if (first) {
          first = false;
          html.classList.add("hx-motion");
        }
      },
      { rootMargin: "0px 0px -12% 0px" },
    );
    targets.forEach((el) => io.observe(el));
    if (targets.length === 0) html.classList.add("hx-motion");
    const unfollow = followUnderline();

    return () => {
      io.disconnect();
      unfollow();
      html.classList.remove("hx-motion");
      targets.forEach((el) => el.removeAttribute("data-mo"));
    };
  }, []);
}
